import { combineReducers } from '@reduxjs/toolkit';
import { withResetState } from 'src/store/actions';
import apiKeysReducer, {
  initialState as apiKeysInitialState,
} from 'src/store/trading/apiKeys/slice';
import tasksReducer from 'src/store/trading/tasks/slice';
import tradingBalancesReducer, {
  initialState as balancesInitialState,
} from 'src/store/trading/balances/slice';
import tradingTaskFormReducer, {
  initialState as tradingTaskFormInitialState,
} from 'src/store/trading/apiKeys/taskForm/slice';
import tradingBotsReducer, {
  initialState as tradingBotsInitialState,
} from 'src/store/trading/bots/slice';
import tradersReducer from 'src/store/trading/traders/slice';
import tradingBalancesUIReducer from 'src/store/trading/balance-table-opts/slice';
import tradingAccountsReducer from 'src/store/trading/accounts/slice';
import tradingExchangesReducer, {
  initialState as exchangesInitialState,
} from 'src/store/trading/exchanges/slice';
import tradingBalanceHistoryReducer, {
  initialState as balanceHistoryInitialState,
} from 'src/store/trading/balance-history/slice';
import tradingReportReducer, {
  initialState as tradingReportInitialState,
} from 'src/store/trading/reports/slice';

import dexEsReducer from 'src/store/trading/dex/slice';
import tradingViewReducer, {
  initialState as initialTradingViewSlice,
} from 'src/store/trading/trading-view/slice';

export default combineReducers({
  balanceHistory: withResetState(tradingBalanceHistoryReducer, balanceHistoryInitialState),
  balancesUI: tradingBalancesUIReducer,
  accounts: tradingAccountsReducer,
  exchanges: withResetState(tradingExchangesReducer, exchangesInitialState),
  apiKeys: withResetState(apiKeysReducer, apiKeysInitialState),
  tasks: tasksReducer,
  balances: withResetState(tradingBalancesReducer, balancesInitialState),
  taskForm: withResetState(tradingTaskFormReducer, tradingTaskFormInitialState),
  bots: withResetState(tradingBotsReducer, tradingBotsInitialState),
  dexSetup: dexEsReducer,
  traders: tradersReducer,
  tradingView: withResetState(tradingViewReducer, initialTradingViewSlice),
  reports: withResetState(tradingReportReducer, tradingReportInitialState),
});
